import { Link } from 'react-router-dom';
import '../../css/components/LinkRootBlocks.css';

export default function LinkRootBlocks({ maintitle, blocks, columnsPerRow }) {
    // Calculamos el tamaño de columna en Bootstrap (12 columnas por fila)
    const colSize = 12 / columnsPerRow; // ejemplo: 12 / 4 = 3 => col-md-3

    return (
        <div className="container" id="linkroot">
            <h1 className="text-center mb-5">{maintitle}</h1>
            <div className="row gy-4">
                {blocks.map((block, index) => (
                    <div key={index} className={`col-xl-${colSize} col-md-6 d-flex`}>
                        <Link to={block.link} className="w-100 text-decoration-none">
                            <div className="service-item position-relative h-100 rounded-2" style={{ backgroundColor: 'rgba(245, 245, 245, 0.1)'}}>
                                <div className="icon"><i className={block.ico}></i></div>
                                <h4>{block.title}</h4>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}